/**
 * 評価フローから除外する項目。
 *
 * 旧: フリー項目（TECH-B-16 / SALES-B-15 / ADMIN-B-13）を独立目標 evaluation_goals へ
 *     移行したため除外していた。
 * 現: フリー項目は「会社が求める項目以外に、本人が設定したい項目」として全部門10点で
 *     評価フローへ復帰したため、除外対象は存在しない（マイグレーション129）。
 *     設計: 設計書類/02_評価管理機能/目標設定の項目別化と個人別重み設計.md §3.2
 *
 * 仕組み自体は将来の項目除外に備えて残す。
 * バックエンドの backend/src/utils/evaluationGoalConstants.ts と内容を一致させること。
 */
const EXCLUDED_ITEM_IDS = new Set<string>([]);

export function isExcludedEvaluationItem(itemId: string): boolean {
  return EXCLUDED_ITEM_IDS.has(itemId);
}

export function filterExcludedEvaluationItems<T extends { item_id: string }>(items: T[]): T[] {
  return items.filter((item) => !isExcludedEvaluationItem(item.item_id));
}
